import React from 'react';

import {
  GetPdpBaseInfo_catalog_product_base_info_brand_home,
  GetPdpBaseInfo_catalog_product_base_info_shop,
} from '@domains/pdp-common';

import * as S from '../styles/styles';

interface SellerInfoProps {
  shop: GetPdpBaseInfo_catalog_product_base_info_shop;
}

export const SellerInfo: React.FC<React.PropsWithChildren<SellerInfoProps>> = ({ shop }) => {
  return (
    <S.BrandHomeSellerWrap>
      <S.BrandHomeSeller>
        <span>판매자</span>
        <span>{shop.name}</span>
      </S.BrandHomeSeller>
    </S.BrandHomeSellerWrap>
  );
};
